import { SvgIconProps } from '@traba/types'

export function Sun({
  size,
  color = '#7A8A99',
  strokeWidth = '1.5',
  ...rest
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M12.2078 3.79223L12.2857 3.71429M3.71429 12.2858L3.79221 12.2078M8 2.04929V2M8 14V13.9507M2.04929 8H2M14 8H13.9507M3.79221 3.79223L3.71427 3.71429M12.2857 12.2857L12.2078 12.2078"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
